export const menu = {
    label: 'CheckIn QRCode',
    icon: 'pi pi-fw pi-qrcode',
    to: '/agenciaconceito/checkins/qrcode/ler',
    rules: ['AGECON-CHECKIN-02'],
};
